import { createReduxHooks } from "@skydio/react_util";

import type { AppStore } from "state/store";

export const { useSelector, useShallowSelector, useDispatch } = createReduxHooks<AppStore>();
